export default __webpack_public_path__ + "static/media/Q0001.2f6c61de.png";